import NthEdition from "../../../../common/features/asset/NthEdition.tsx";
import styles from "./BookDetails.module.scss";
import TruncatedTitle from "../../../../common/features/asset/TruncatedTitle.tsx";
import { ManageAsset } from "../../../../common/api/decimal/common-types/manageAssets.ts";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";

interface BookDetailsProps {
  asset: ManageAsset;
  showEdition?: boolean;
  showAuthor?: boolean;
  className?: string;
  assetLink?: string;
}

export default function BookDetails({
  asset,
  showEdition,
  showAuthor,
  className,
  assetLink,
}: BookDetailsProps) {
  return (
    <div className={className}>
      {assetLink ? (
        <BaseLinkOrButton href={assetLink} className={styles.title}>
          <TruncatedTitle asset={asset} />
        </BaseLinkOrButton>
      ) : (
        <TruncatedTitle className={styles.title} asset={asset} />
      )}
      {showEdition && <NthEdition asset={asset} className={styles.edition} />}
      {showAuthor && <div className={styles.author}>{asset.author}</div>}
    </div>
  );
}
